module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai771-2eaa9a849a6d5e62f8f19501e317bb22.jpg";